export default __webpack_public_path__ + "static/media/download1.3ca42f64.svg";